import {
    CommentDialog,
    SaveTemplateDialog,
    UseTemplate,
} from "@dv5/components"
import {Comment, Template, TemplateItemParams, TemplateType} from "@dv5/domain"
import {CommentService} from "../services/commentService"
import {FC} from "react"

interface Props {
    showAddCommentDialog: boolean
    clickedWidgetId: string | null
    widgetComments: Record<string, Comment[]>
    commentService: CommentService
    onCloseCommentDialog: () => void
    markdownComments?: boolean

    showSaveTemplateDialog: boolean
    onSaveTemplate: (title: string) => void
    onCancelSaveTemplate: () => void

    showUseTemplateDialog: boolean
    onTemplateSelect: (template: Template, params: TemplateItemParams) => void
    onCancelTemplate: () => void
}

export const CanvasActionDialogs: FC<Props> = ({
    showAddCommentDialog,
    clickedWidgetId,
    widgetComments,
    commentService,
    onCloseCommentDialog,
    markdownComments = false,
    showSaveTemplateDialog,
    onSaveTemplate,
    onCancelSaveTemplate,
    showUseTemplateDialog,
    onTemplateSelect,
    onCancelTemplate,
}) => (
    <>
        {showAddCommentDialog && clickedWidgetId && (
            <CommentDialog
                isOpen={showAddCommentDialog}
                sourceItemId={clickedWidgetId}
                comments={widgetComments[clickedWidgetId] ?? []}
                onGetComment={(id) => commentService.loadComments(id)}
                onSend={(content) => commentService.sendComment(content)}
                onEdit={(commentId, content) => commentService.editComment(commentId, content)}
                onDelete={(commentId) => commentService.deleteComment(commentId)}
                onClose={onCloseCommentDialog}
                markdown={markdownComments}
            />
        )}
        {showSaveTemplateDialog && (
            <SaveTemplateDialog
                title="Save as a template..."
                templateType={TemplateType.CANVAS_WIDGETS}
                onSave={onSaveTemplate}
                onCancel={onCancelSaveTemplate}
            />
        )}
        {showUseTemplateDialog && (
            <UseTemplate
                templateTypes={[TemplateType.CANVAS_WIDGETS]}
                onSelect={onTemplateSelect}
                onCancel={onCancelTemplate}
            />
        )}
    </>
)
